import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

function CancellationTerms() {
    const { t } = useTranslation();

    useEffect(() => {
        window.scrollTo(0, 0);
        document.title = `${t('cancellationTermsTitle')} — KODPİLOT`;
    }, [t]);

    return (
        <div className="legal">
            <div className="legal-inner">
                        <h1 style={{ 
                            color: '#FC0DC3', 
                            fontFamily: 'Chakra Petch', 
                            fontWeight: '700', 
                            fontSize: '36px',
                            marginBottom: '50px', 
                            textAlign: 'left',
                            textTransform: 'uppercase'
                        }}>
                            İPTAL, İADE VE CAYMA KOŞULLARI
                        </h1>

                        <div className="legal-card">
                            
                            <p style={{ marginBottom: '30px' }}>
                                İşbu İptal, İade ve Cayma Koşulları; Kodpilot Yazılım Teknoloji San. ve Tic. Ltd. Şti. (“Şirket”) tarafından sunulan hizmetlerin satışına ilişkin olarak, 6502 sayılı Tüketicinin Korunması Hakkında Kanun ve ilgili Mesafeli Sözleşmeler Yönetmeliği hükümleri uyarınca düzenlenmiştir.
                            </p>

                            <section style={{ marginBottom: '30px' }}>
                                <h2 style={{ color: '#fff', fontSize: '20px', marginBottom: '15px', fontFamily: 'Chakra Petch' }}>1. Hizmetin Kapsamı</h2>
                                <p>Kodpilot tarafından sunulan hizmetler; yazılım geliştirme, danışmanlık, dijital ürün ve teknoloji hizmetleri gibi fiziki teslimat içermeyen, dijital veya hizmet niteliğindeki ürünlerden oluşmaktadır.</p>
                            </section>

                            <section style={{ marginBottom: '30px' }}>
                                <h2 style={{ color: '#fff', fontSize: '20px', marginBottom: '15px', fontFamily: 'Chakra Petch' }}>2. Cayma Hakkı</h2>
                                <p>Tüketici, hizmet satışına ilişkin sözleşmelerde, hizmetin ifasına başlanmamış olması kaydıyla, sözleşmenin kurulduğu tarihten itibaren 14 (on dört) gün içerisinde herhangi bir gerekçe göstermeksizin cayma hakkına sahiptir.</p>
                            </section>

                            <section style={{ marginBottom: '30px' }}>
                                <h2 style={{ color: '#fff', fontSize: '20px', marginBottom: '15px', fontFamily: 'Chakra Petch' }}>3. Cayma Hakkının Kullanılamayacağı Haller</h2>
                                <p>Aşağıdaki durumlarda cayma hakkı kullanılamaz:</p>
                                <ul style={{ listStyleType: 'disc', paddingLeft: '20px' }}>
                                    <li>Hizmetin, tüketicinin onayı ile cayma süresi dolmadan ifasına başlanmış olması</li>
                                    <li>Tüketiciye özel olarak hazırlanan, kişiye veya kuruma özgü hizmetler</li>
                                    <li>Anında ifa edilen dijital hizmetler</li>
                                    <li>Hizmetin tamamlanmış olması</li>
                                </ul>
                                <p style={{ marginTop: '10px' }}>Bu hallerde tüketici, cayma hakkından feragat etmiş sayılır.</p>
                            </section>

                            <section style={{ marginBottom: '30px' }}>
                                <h2 style={{ color: '#fff', fontSize: '20px', marginBottom: '15px', fontFamily: 'Chakra Petch' }}>4. İptal Koşulları</h2>
                                <p>Hizmet henüz başlatılmamış ise, tüketici iptal talebinde bulunabilir.<br/>
                                Hizmetin başlatılmış veya kısmen ifa edilmiş olması durumunda iptal talepleri kabul edilmez.<br/>
                                Hizmete ilişkin iptal talepleri yazılı olarak (e-posta yoluyla) iletilmelidir.</p>
                            </section>

                            <section style={{ marginBottom: '30px' }}>
                                <h2 style={{ color: '#fff', fontSize: '20px', marginBottom: '15px', fontFamily: 'Chakra Petch' }}>5. İade Koşulları</h2>
                                <ul style={{ listStyleType: 'disc', paddingLeft: '20px' }}>
                                    <li>Cayma hakkının geçerli şekilde kullanılması halinde, tahsil edilen bedel 14 gün içerisinde tüketiciye iade edilir.</li>
                                    <li>İadeler, ödeme sırasında kullanılan ödeme yöntemi ile yapılır.</li>
                                    <li>Hizmet ifasına başlanmış veya tamamlanmış ise iade yapılmaz.</li>
                                </ul>
                            </section>

                            <section style={{ marginBottom: '30px' }}>
                                <h2 style={{ color: '#fff', fontSize: '20px', marginBottom: '15px', fontFamily: 'Chakra Petch' }}>6. Hizmetin Ayıplı Olması</h2>
                                <p>Sunulan hizmetin sözleşmede belirtilen niteliklere aykırı olması halinde, tüketici durumu makul süre içerisinde Şirket’e bildirmekle yükümlüdür.<br/>
                                Taraflar, ayıbın giderilmesi veya hizmetin yeniden sunulması konusunda mutabakata varabilir.</p>
                            </section>

                            <section style={{ marginBottom: '30px' }}>
                                <h2 style={{ color: '#fff', fontSize: '20px', marginBottom: '15px', fontFamily: 'Chakra Petch' }}>7. İade Sürecinde Sorumluluk</h2>
                                <p>Banka veya ödeme kuruluşlarından kaynaklanan gecikmelerden Şirket sorumlu değildir.<br/>
                                İade işlemi, Şirket tarafından başlatıldıktan sonra sürecin tamamlanması ilgili finans kuruluşunun prosedürlerine bağlıdır.</p>
                            </section>

                            <section style={{ marginBottom: '30px' }}>
                                <h2 style={{ color: '#fff', fontSize: '20px', marginBottom: '15px', fontFamily: 'Chakra Petch' }}>8. İletişim</h2>
                                <p>İptal, iade ve cayma talepleriniz için bizimle aşağıdaki kanallar üzerinden iletişime geçebilirsiniz:</p>
                                <p><strong>E-posta:</strong> <a href="mailto:info@kodpilot.com" style={{ color: '#FC0DC3', textDecoration: 'none' }}>info@kodpilot.com</a><br/>
                                <strong>Web:</strong> <a href="https://www.kodpilot.com" target="_blank" rel="noreferrer" style={{ color: '#FC0DC3', textDecoration: 'none' }}>www.kodpilot.com</a></p>
                            </section>

                            <section style={{ marginBottom: '30px' }}>
                                <h2 style={{ color: '#fff', fontSize: '20px', marginBottom: '15px', fontFamily: 'Chakra Petch' }}>9. Yürürlük</h2>
                                <p>İşbu İptal, İade ve Cayma Koşulları, www.kodpilot.com internet sitesinde yayınlandığı tarihten itibaren geçerli olup, Şirket tarafından gerekli görüldüğü takdirde güncellenebilir.</p>
                            </section>
                        </div>
            </div>
        </div>
    );
}

export default CancellationTerms;
